import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import {
  selectAddressCurrentContractActive,
  selectConfigCurrentContractActive,
  selectContractDetailsCurrentContractActive,
  selectCurrentOrFirstContract,
  selectPersonalContactSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateContractDetailsData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { selectCurrentContractActive } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useSaveButtons = ({ setIsOpen = null }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { id } = useRetrieveActiveContractIdAndType()
  const { businessCard } = useSelector(selectContractDetailsCurrentContractActive)
  const { firstname: ownerName, lang } = useSelector(selectAuthData)
  const { email, phone1: phone } = useSelector(selectPersonalContactSubscriptionData)
  const { city, electricityMeter, gasMeter } = useSelector(selectAddressCurrentContractActive)
  const currentContract = useSelector(selectCurrentOrFirstContract)
  const providerName = currentContract?.config?.providerConfiguration?.name ?? ''
  const pdl = electricityMeter?.pdlNo
  const pce = gasMeter?.pceNo
  const dateLanguage = `${lang}-${lang.toUpperCase()}`
  const date = new Date().toLocaleString(dateLanguage, { timeZone: 'Europe/Paris' })
  const normalizedProvider = providerName?.toLowerCase().replace(/\s+/g, '_')
  const customKey = `subscriptionForm:header.modal.recording_script_${normalizedProvider}`
  const recordingScriptText = t([customKey, 'subscriptionForm:header.modal.recording_script'], {
    ownerName,
    providerName,
    date,
    email,
    phone,
    city,
    pdl,
    pce,
  })

  const { isSaving, completeStatusInfo = null } = useSelector(selectConfigCurrentContractActive)
  const { transfertLog = null } = useSelector(selectCurrentContractActive)
  const { isEditable, resendAllowed, errors = {}, lastSentDate } = useFormStatus()
  const hasBeenSentBefore = !!(lastSentDate && resendAllowed)
  const saveAndSendLabel = t(
    hasBeenSentBefore ? ['common:save_and_resend', 'common:save_and_send'] : 'common:save_and_send',
  )
  const saveContract = (actionType = 'save') => {
    dispatch({
      type: subscriptionFormActionsV2.CONTRACT_SAVE,
      enqueue,
      action: actionType,
      closeModal: setIsOpen,
    })
  }

  const contractUpdate = payload => {
    dispatch(updateContractDetailsData({ id, data: payload }))
  }

  return {
    saveContract,
    contractUpdate,
    isSaving,
    t,
    businessCard,
    isEditable,
    resendAllowed,
    completeStatusInfo,
    errors,
    transfertLog,
    hasError: Object.keys(errors).length > 0,
    hasPodError: !!errors.address_pod_id_elec || !!errors.address_pod_id_gas || !!errors.address_pod_id_dual,
    saveAndSendLabel,
    recordingScriptText,
  }
}

export default useSaveButtons
